export interface SortState<K extends string> {
  key: K;
  dir: "asc" | "desc";
}

// SortableHeader is a people-table column header that toggles the table's sort
// when clicked. Shared by the admin People table and the Blocks achievement
// table so both sort the same way.
export function SortableHeader<K extends string>({
  label,
  sortKey,
  sort,
  onClick,
  align
}: {
  label: string;
  sortKey: K;
  sort: SortState<K>;
  onClick: (key: K) => void;
  align: "left" | "right";
}) {
  const active = sort.key === sortKey;
  return (
    <th
      scope="col"
      aria-sort={active ? (sort.dir === "asc" ? "ascending" : "descending") : "none"}
      className={`people-table__th people-table__th--${align}${active ? " is-active" : ""}`}
    >
      <button type="button" className="people-table__sort-btn" onClick={() => onClick(sortKey)}>
        <span>{label}</span>
        <span className="people-table__sort-arrow" aria-hidden="true">
          {active ? (sort.dir === "asc" ? "↑" : "↓") : "↕"}
        </span>
      </button>
    </th>
  );
}
